import { useServices } from "inject-typesafe-react";
import { useAsyncCallback } from "react-use-async-callback";
import { AppServices } from "../../../configure/configureServices";
import { AsyncActionStatus } from "../../../shared/abstractStore";

/*
 * Get a callback to send a reminder to a user to complete a questionnaire.
 */
export function useSendAssessmentReminderCallback(): [(userId: string, assessmentId: string) => Promise<void>, AsyncActionStatus]
{
    var api = useServices((services: AppServices) => services.apiFetch());
    //callback to get the userId, AssessmentId, Assessment Name. 
    const [callback, status] = useAsyncCallback(async (userId: string, assessmentId: string) => {
        await api.post(`/api/reminders/sendReminder`, { userId: userId, assessmentId: assessmentId});
    }, [api]);

    return [callback, status];
}